import { render, staticRenderFns } from "./EditMultipleChoiceAnswer.vue?vue&type=template&id=251ced40&"
import script from "./EditMultipleChoiceAnswer.vue?vue&type=script&lang=js&"
export * from "./EditMultipleChoiceAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports